import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskListHeaderComponent } from './task-list-header/task-list-header.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { TaskListComponent } from './task-list/task-list.component';
import { TaskListItemComponent } from './task-list-item/task-list-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiSwipeModule } from '@fi-shared/fi-directives/fi-swipe/fi-swipe.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FormsModule } from '@angular/forms';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiTaskV2SharedComponentsModule } from '@fi-app/task-v2/components/fi-task-v2-shared-components.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatTabsModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        FiSwipeModule,
        FiAppTextSharedModule,
        FiAttachmentsModule,
        FiProfileIconModule,
        FiBindHtmlCompileModule,
        FormsModule,
        FiWrapperTableModule,
        FiWhenScrolledModule,
        FiTaskV2SharedComponentsModule,
    ],
    declarations: [TaskListHeaderComponent, TaskListComponent, TaskListItemComponent],
    exports: [TaskListHeaderComponent],
})
export class TaskListModule {}
